import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFound from './404';
import Comparison from './comparison';
import ContentLibrary from './content_library';
import DocumentView from './document_view';
import Error from './error';
import Example from './example';
import FileViewComparison from './file_view_comparison';
import Home from './home';
import Landing from './landing';
import ProjectsWorkspace from './projects_workspace';
import ProtectedRoute from './protected_route';
import RecentActivityView from './recent_activity';
function GeniusRouter() {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: 'example', element: React.createElement(ProtectedRoute, null,
                React.createElement(Example, null)) }),
        React.createElement(Route, { path: 'compare/:id/*', element: React.createElement(ProtectedRoute, null,
                React.createElement(Comparison, null)) }),
        React.createElement(Route, { path: 'content-library', element: React.createElement(ProtectedRoute, null,
                React.createElement(ContentLibrary, null)) }),
        React.createElement(Route, { path: 'document/:id', element: React.createElement(ProtectedRoute, null,
                React.createElement(DocumentView, null)) }),
        React.createElement(Route, { path: 'doc-comparison-view/:id', element: React.createElement(ProtectedRoute, null,
                React.createElement(FileViewComparison, null)) }),
        React.createElement(Route, { path: 'projects-workspace/:activeTab?/:folderId', element: React.createElement(ProtectedRoute, null,
                React.createElement(ProjectsWorkspace, null)) }),
        React.createElement(Route, { path: 'recent-activity/:tab?', element: React.createElement(ProtectedRoute, null,
                React.createElement(RecentActivityView, null)) }),
        React.createElement(Route, { path: 'error', element: React.createElement(Error, null) }),
        React.createElement(Route, { path: 'login/callback/:stateId', element: React.createElement(Landing, null) }),
        React.createElement(Route, { path: 'login', element: React.createElement(Landing, null) }),
        React.createElement(Route, { path: '401', element: React.createElement(NotFound, null) }),
        React.createElement(Route, { path: '/', element: React.createElement(ProtectedRoute, null,
                React.createElement(Home, null)) }),
        React.createElement(Route, { path: '*', element: React.createElement(NotFound, null) })));
}
export default GeniusRouter;
